import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function TargetAudience() {
  const forWho = ['Networkers estancados que se quedaron sin lista de contactos.', 'Líderes que quieren un sistema duplicable para sus equipos nuevos.', 'Personas que tienen un empleo y solo tienen 1 hora al día para su negocio.', 'Emprendedores que odian las ventas agresivas y prefieren el marketing de atracción.'];
  const notForWho = ["Gente que busca 'dinero fácil' sin publicar contenido.", 'Personas que no están dispuestas a mostrarse mínimamente en cámara.', "Networkers que creen que 'el sistema de hace 20 años' sigue siendo la única forma."];
  return <section className="bg-brand-darker px-6 py-20 md:py-28" data-id="element-245">
      <div className="mx-auto max-w-5xl" data-id="element-246">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-247">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-light rounded-2xl p-8 border border-green-500/20 relative overflow-hidden" data-id="element-248">
            <div className="absolute top-0 left-0 w-full h-1 bg-green-500" data-id="element-249"></div>
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-250">
              <div className="bg-green-500/20 p-2 rounded-full" data-id="element-251">
                <Check className="w-6 h-6 text-green-500" data-id="element-252" />
              </div>
              ESTO SÍ ES PARA TI SI...
            </h3>

            <ul className="space-y-6" data-id="element-253">
              {forWho.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-254">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-255" />
                  <span className="text-slate-300 text-lg" data-id="element-256">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is NOT for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-light rounded-2xl p-8 border border-red-500/20 relative overflow-hidden" data-id="element-257">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-258"></div>
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-259">
              <div className="bg-red-500/20 p-2 rounded-full" data-id="element-260">
                <X className="w-6 h-6 text-red-500" data-id="element-261" />
              </div>
              ESTO NO ES PARA TI SI...
            </h3>

            <ul className="space-y-6" data-id="element-262">
              {notForWho.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-263">
                  <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-264" />
                  <span className="text-slate-400 text-lg" data-id="element-265">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}